export default __webpack_public_path__ + "static/media/Motorhomes_Logo.5b350f03.jpg";